import path from 'path';
import { isUrl, useSelector } from '@topwrite/common';

export default function useFilename(src?: string) {
    const { current } = useSelector('workspace');
    if (src && !isUrl(src)) {
        if (src.startsWith('/')) {
            return src.slice(1);
        }
        return path.join(path.dirname(current || ''), src);
    }
    return undefined;
}
